import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/i18n/messages/en'
import en from 'vuetify/lib/locale/en'
import ru from 'vuetify/lib/locale/ru'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'ru',
  fallbackLocale: 'en',
  messages: {
    en: {
      ...messages,
      $vuetify: en,
    },
    ru: {
      ...messages,
      $vuetify: ru,
    },
  },
})
